import { createStyles } from '@material-ui/core'

const styles = theme =>
  createStyles({
    noRows: {
      height: 50,
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    tableWrapper: {
      overflowX: 'auto',
    },
  })

export default styles
